import { POINT_TYPES } from '../config'

export const getPointTypeIndex = (type?: string) =>
  type && POINT_TYPES.indexOf(type) !== -1 ? POINT_TYPES.indexOf(type) : 0
